import Axios from "../api/axios";
import config from "../../config";

const getEt1Letter = () => {
  return Axios.get(`${config.BASE_URL}et1-letter`);
};

export default getEt1Letter;
